import BarChartIcon from '@mui/icons-material/BarChart';
import DescriptionIcon from '@mui/icons-material/Description';
import GroupsIcon from '@mui/icons-material/Groups';
import { NavLink } from 'react-router-dom';
import { t } from '../../i18n';

/**
 * SideMenu — fixed left sidebar (203 px wide) with logo and nav links.
 */
export const SideMenu: React.FC = () => (
  <nav className="side-nav">
    {/* Logo */}
    <div className="side-nav__body">
      <NavLink to="/" end>
        <img className="side-nav__logo" src="/img/img_saisoku_logo.svg" alt="logo" />
      </NavLink>
    </div>

    {/* Primary navigation */}
    <div className="side-nav__list">
      {/* Temporary hide */}
      {/* <div className="side-nav__group">
        <span className="side-nav__group-title">{t('nav_home')}</span>
        <ul className="nav side-nav__group-list">
          <li>
            <NavLink
              to="/"
              end
              className={({ isActive }) => `nav-link nav-link--extend${isActive ? ' active' : ''}`}
            >
              <HomeIcon className="side-nav__item-icon" />
              <span>{t('nav_home')}</span>
            </NavLink>
          </li>
        </ul>
      </div> */}
      <div className="side-nav__group">
        <span className="side-nav__group-title">{t('nav_group_dashboard')}</span>
        <ul className="nav side-nav__group-list">
          <li>
            <NavLink
              to="/dashboard"
              className={({ isActive }) => `nav-link nav-link--extend${isActive ? ' active' : ''}`}
            >
              <BarChartIcon className="side-nav__item-icon" />
              <span>{t('nav_dashboard')}</span>
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="side-nav__separator" />

      <div className="side-nav__group">
        <span className="side-nav__group-title">{t('nav_group_applicant_import')}</span>
        <ul className="nav side-nav__group-list">
          <li>
            <NavLink
              to="/use-media"
              className={({ isActive }) => `nav-link nav-link--extend${isActive ? ' active' : ''}`}
            >
              <GroupsIcon className="side-nav__item-icon" />
              <span>{t('nav_use_media')}</span>
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="side-nav__separator" />

      <div className="side-nav__group">
        <span className="side-nav__group-title">{t('nav_group_mail_sms')}</span>
        <ul className="nav side-nav__group-list">
          <li>
            <NavLink
              to="/template"
              className={({ isActive }) => `nav-link nav-link--extend${isActive ? ' active' : ''}`}
            >
              <DescriptionIcon className="side-nav__item-icon" />
              <span>{t('nav_template')}</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  </nav>
);
